import classnames from 'classnames'
import { Component, ReactNode } from 'react'
import { NoteTopicDto } from '../../../../definition/notes.dto'

import { toast } from 'react-toastify'
import { asyncCreateTopic, asyncSaveTopic } from '../../../../services/notes.service'
import plusIcon from './../../../../styles/images/plus-icon.png'

export interface EditTopicProps {
  topic?: NoteTopicDto

  onNewCb: (dto: NoteTopicDto) => void
  onSaveCb: (dto: NoteTopicDto) => void
  removeSelected: () => void
}

export interface EditTopicState {
  topicId?: string
  topicName: string
  topicError?: boolean

  isNew: boolean
  isEditing: boolean
}

export class EditTopic extends Component<EditTopicProps, EditTopicState> {
  constructor(props: EditTopicProps) {
    super(props)

    this.state = {
      topicId: this.props.topic?.id,
      topicName: this.props.topic?.name || '',

      isNew: !this.props.topic,
      isEditing: !!this.props.topic
    }
  }

  componentDidUpdate(prevProps: Readonly<EditTopicProps>): void {
    if (this.props.topic !== prevProps.topic) {
      this.setState({
        topicId: this.props.topic?.id || '',
        topicName: this.props.topic?.name || '',

        isNew: !this.props.topic,
        isEditing: !!this.props.topic
      })
    }
  }

  onAddTopic = () => {
    this.setState({
      isNew: true,
      isEditing: false,
      topicId: '',
      topicName: ''
    })
    this.props.removeSelected()
  }

  onSave = async () => {
    if (!this.state.topicName) {
      this.setState({
        topicError: true
      })
      return
    }

    if (this.state.isNew) {
      try {
        const topic = await asyncCreateTopic({
          name: this.state.topicName
        })
        this.props.onNewCb && this.props.onNewCb(topic!)
      } catch (error: any) {
        const errMsg = error.response?.data?.error?.message || error.message
        console.error(errMsg)
        toast.error(<>{errMsg}</>)
      }
    } else {
      try {
        const topic = {
          id: this.state.topicId!,
          name: this.state.topicName
        }
        await asyncSaveTopic(topic)
        this.props.onSaveCb && this.props.onSaveCb(topic)
      } catch (error: any) {
        const errMsg = error.response?.data?.error?.message || error.message
        console.error(errMsg)
        toast.error(<>{errMsg}</>)
      }
    }
  }

  render(): ReactNode {
    return (
      <div className='topic-section'>
        <div className='add-topic'>
          <img src={plusIcon} alt='Add Topic' onClick={this.onAddTopic} />
          <label>Add Topic</label>
        </div>

        <div className='new-note-topic'>
          <div className={classnames('column')}>
            <div className='label-input'>
              <label>Topic Name</label>
              <input
                className={this.state.topicError ? 'input-error' : ''}
                value={this.state.topicName}
                onChange={(e) => {
                  this.setState({
                    topicName: e.target.value,
                    topicError: !e.target.value
                  })
                }}
              />
            </div>

            <div className='row right-panel'>
              <div className='action-button column'>
                <button className='primary' onClick={this.onSave}>
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
